// extracted by mini-css-extract-plugin
export default {"banned":"Banned_banned__VRoXk","bannedContainer":"Banned_bannedContainer__5NFZq"};